import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "../../utils/helpers";
import dataService from "../../api";

const state = {
    isLoggedIn: false,
    permissions: [],
    user:{},
    lastRequestOn :  new Date(),
    token: window.localStorage.getItem('token'),

};
  
const getters = {
    hasPermission: (state) => (permissionId) => {
        return state.permissions.includes(permissionId)
    },
}
 
const mutations = {
    setLastRequestOn: (state) => (state.lastRequestOn =  new Date()),
    setLoginState: (state, isLoggedIn) => (state.isLoggedIn = isLoggedIn),
    setPermissions: (state, permissions) => (state.permissions = permissions),
    setUserInfo: (state, user) => (state.user = user),

    setToken: (state, token) => {
        state.token = token;
        window.localStorage.setItem('token', token);
    },
};

  
const actions = {
    async login({ commit }, payload) {
        try {
            startLoading()
                const response = await dataService.security.Login(payload);
                stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            if (response.data.authenticatedUser.status!=7) {
                commit("setLoginState", true);
            }
                var user = {
                    userId: response.data.authenticatedUser.userId,
                    loginName: response.data.authenticatedUser.loginName,
                    status: response.data.authenticatedUser.status,
                    userTypeId: response.data.authenticatedUser.userTypeId,
                    employeeName: response.data.authenticatedUser.employeeName,
                    doctorName: response.data.authenticatedUser.doctorName,
                    doctorId: response.data.authenticatedUser.doctorId,
                }
                commit("setUserInfo", user);
                commit("setPermissions", response.data.authenticatedUser.permissions);
            commit("setToken", response.data.token);

                return Promise.resolve(response.data);
    
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },   
     
        async loginStatus({ commit }) {
            try {
                const response = await dataService.security.LoginStatus();

                if (!response.data.statusCode) {
                    // showAlert(serverErrorMessage);
                    return;
                }
                var user = {
                    userId: response.data.authenticatedUser.userId,
                    loginName: response.data.authenticatedUser.loginName,
                    status: response.data.authenticatedUser.status,
                    userTypeId: response.data.authenticatedUser.userTypeId,
                    employeeName: response.data.authenticatedUser.employeeName,
                    doctorName: response.data.authenticatedUser.doctorName,
                    doctorId: response.data.authenticatedUser.doctorId,
                }
                if (response.data.authenticatedUser.status != 7) {
                    commit("setLoginState", true);
                }
                commit("setUserInfo", user);
                commit("setToken", response.data.token);

                commit("setPermissions", response.data.authenticatedUser.permissions);

            } catch (error) {
                commit("setLoginState", false);
            }
        },
        async logout({ commit }) {
            try {
                startLoading()
                const response = await dataService.security.Logout();

                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                // Remove token from local storage
                localStorage.removeItem('token');

                showNotification(response.data.message)

                resetStore(commit);
            } catch (error) {
                stopLoading()
                resetStore(commit);
            }
        },
        async resetSession({ commit }) {
            try {
                startLoading()
                const response = await dataService.security.resetSession();

                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
            } catch (error) {
                stopLoading()
                resetStore(commit);

                // catchHandler(error);
                // return Promise.reject(error);
            }
        },

    
   
}


function resetStore(commit) {
    commit("setLoginState", false);
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};